import { Pipe, PipeTransform } from "@angular/core";
import { formatEnumString } from "../pipe-enum-utils";

@Pipe({
  name: "enumStringDisplay",
})
export class EnumStringPipe implements PipeTransform {
  transform(value: string): any {
    return formatEnumString(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/enum-string.pipe.ts